import React from "react";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { FilterField } from "../../style/filter";

const Filter = ({dealerCode = "", dealerName="", city="", financialYear="", period = "", frequency=""}) => {
  return (
    <>
      {dealerCode && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>Dealer Code</label>
            <input type="text" value={dealerCode} disabled readOnly />
          </FilterField>
        </Grid>
      )}

      {dealerName && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>Dealership Name</label>
            <input type="text" value={dealerName} disabled readOnly />
          </FilterField>
        </Grid>
      )}

      {city && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>City</label>
            <input type="text" value={city} disabled readOnly />
          </FilterField>
        </Grid>
      )}

      {financialYear && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>Financial Year</label>
            <input type="text" value={financialYear} disabled readOnly />
          </FilterField>
        </Grid>
      )}

      {period && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>Period</label>
            <input type="text" value={period} disabled readOnly />
          </FilterField>
        </Grid>
      )}

      {frequency && (
        <Grid item xs={6} sm={4} lg={2}>
          <FilterField>
            <label>Frequency</label>
            <input type="text" value={frequency} disabled readOnly />
          </FilterField>
        </Grid>
      )}
    </>
  );
};

export default Filter;
